import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { colors } from "../config/colors";
import { FONT_SIZE_LG, FONT_WEIGHT_MEDIUM, LINE_HEIGHT_MD } from "../config/styles";

const StyledFormSection = styled("div")({
  marginBottom: "24px",
  
  "& .section-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  
  "& .section-title": {
    fontSize: FONT_SIZE_LG,
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: LINE_HEIGHT_MD,
    color: colors.custom,
    margin: 0,
    fontFamily: "DM Sans",
  },
  
  "& .section-content": {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
});

/**
 * FormSection Component
 * 
 * Reusable section wrapper for forms with optional title and action button.
 * Provides consistent spacing and styling for form sections.
 * 
 * @param {string} title - The section title
 * @param {node} children - The form fields or content
 * @param {node} action - Optional action button (e.g., Edit button)
 */
const FormSection = ({ title, children, action }) => {
  return (
    <StyledFormSection>
      {(title || action) && (
        <div className="section-header">
          {title && <h3 className="section-title">{title}</h3>}
          {action}
        </div>
      )}
      <div className="section-content">
        {children}
      </div>
    </StyledFormSection>
  );
};

FormSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  action: PropTypes.node,
};

FormSection.defaultProps = {
  title: null,
  action: null,
};

export default FormSection;
